import React from "react";
import Link from "components/link/link";

export function AmpRelatedArticle(props: any) {
  const { title, url } = props;
  return (
    <div className="related-articles__item">
      <Link className="related-article" href={url}>
        <h3 className="related-article__title">{title}</h3>
      </Link>
    </div>
  );
}

export default AmpRelatedArticle;
